import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import pharmaSTDImage from "../../../../assets/imgs/services/nationals/pharma-std.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import "../shared-css/national-global-styles.css";
import "./pharma-std.css";
import NationalDescription from "../../../../components/national-description/national-description";
import cajasImage from "../../../../assets/imgs/services/nationals/pharma-xps/cajas.png";
import hightech1Icon from "../../../../assets/imgs/services/nationals/hightech-icons/hightech1.svg";
import courier2Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier2.svg";
import courier5Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier5.svg";
import humanremains1Icon from "../../../../assets/imgs/services/nationals/humanremains-icons/humanremains1.svg";
import condiciones1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones01.svg";
import highvalue3Icon from "../../../../assets/imgs/services/nationals/highvalue-icons/highvalue3.svg";

function PharmaSTD() {
  const [tPharmaSTD] = useTranslation("pharmaStdPage");
  const [tSMetaData] = useTranslation("metaData");
  const idPharmaSTD = "49e9dc7b-4c41-4938-b800-ee5b5c7a5269";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);
  const nonApplicableIcons = [
    humanremains1Icon,
    condiciones1Icon,
    courier2Icon,
  ];
  const additionalConditionIcons = [
    hightech1Icon,
    courier5Icon,
    highvalue3Icon,
  ];

  const getListItems = (translationPath) => {
    const list = tPharmaSTD(`${translationPath}.items`, { returnObjects: true });

    if (Array.isArray(list) && list.length > 0) {
      return list;
    }

    const legacyItems = [1, 2, 3]
      .map((index) => tPharmaSTD(`${translationPath}.item${index}`))
      .filter((item) => item && !item.includes(`${translationPath}.item`));

    return legacyItems;
  };

  const nonApplicableCharges = getListItems("non-applicable-charges");
  const additionalConditions = getListItems("additional-conditions");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[9]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[9]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idPharmaSTD}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Es obligatorio declarar la descripción exacta del producto, en caso de aerosoles o líquidos, entregar la hoja de seguridad del producto (MSDS) a personal de mostrador para la validación del envío. NO serán aceptadas descripciones genéricas.",
                },
              ],
            })
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us[
              "03-Documentation, Acceptance and Delivery"
            ].content
          );
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "It is mandatory to declare the exact description of the product; for aerosols or liquids, submit the product safety data sheet (MSDS) to counter personnel for shipment validation. Generic descriptions will NOT be accepted.",
                },
              ],
            })
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const renderInfoItems = (items, icons) => {
    if (!Array.isArray(items)) return null;

    return items.map((item, index) => (
      <div className="item" key={`${item}-${index}`}>
        <div className="icon">
          <img src={icons[index % icons.length]} alt="" aria-hidden="true" />
        </div>
        <p>{item}</p>
      </div>
    ));
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("pharmaSTD.title")}</title>
        <meta
          name="description"
          content={tSMetaData("pharmaSTD.description")}
        />
      </Helmet>
      <ImageHeader imgBackground={pharmaSTDImage} />
      <div className="info-national-content">
        <NationalDescription
          title={tPharmaSTD("header.title")}
          description={textDescription ? JSON.parse(textDescription) : ""}
          quoteBtn={tPharmaSTD("header.quote-btn")}
          quoteProductID="btnQuoteSTD"
          contactSales={tPharmaSTD("header.contact-sales")}
          contactProductID="btnContactSTD"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tPharmaSTD("header.prepare-charge")}</h3>
          </div>
          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tPharmaSTD("accordion-1.title")}
              content={accordion1 ? JSON.parse(accordion1) : "{}"}
            />
            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tPharmaSTD("accordion-2.title")}
              content={accordion2 ? JSON.parse(accordion2) : "{}"}
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tPharmaSTD("accordion-3.title")}
              content={accordion3 ? JSON.parse(accordion3) : {}}
            />

            {openAccordion === 3 && (
              <div className="std-packaging-status">
                <h5>Estado de su embalaje</h5>
                <p>
                  Todo embalaje debe proporcionar proteccion adecuada de su contenido.
                  Es decir, el tamano del embalaje debe ser proporcional a las
                  dimensiones del producto, debe prevenir la contaminacion de otro
                  producto o fugas o filtraciones.
                </p>
                <img src={cajasImage} alt="Estado de embalaje Pharma STD" />
                <p className="std-packaging-contact">
                  Para mayores informes contacte a su ejecutivo de ventas o a un
                  asesor de Aeromexico Cargo.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="more-info-content pharma-std-more-info">
        <div className="more-info-box">
          <h5>{tPharmaSTD("non-applicable-charges.title")}</h5>
          <div className="icons">{renderInfoItems(nonApplicableCharges, nonApplicableIcons)}</div>
        </div>
        <div className="more-info-box">
          <h5>{tPharmaSTD("additional-conditions.title")}</h5>
          <div className="icons">
            {renderInfoItems(additionalConditions, additionalConditionIcons)}
          </div>
        </div>
      </div>
    </>
  );
}

export default PharmaSTD;
